"use client";

import style from "./style.module.scss";
import Image from "next/image";
import {
  APP_STORE_URL,
  GOOGLE_PLAY_URL,
  UI_TEXT,
  IMAGE_PATHS,
  GENERAL,
  CONFIG,
} from "@/constants";
import { QrOrigin } from "@/types";
import { openExternalLink } from "@/helpers/security-helpers";

const QrPopup = ({
  onClose,
  origin,
}: {
  onClose: () => void;
  origin: QrOrigin;
}) => {
  const handleOpenLink = () => {
    const url =
      origin === CONFIG.QR_ORIGIN.APP_STORE ? APP_STORE_URL : GOOGLE_PLAY_URL;
    openExternalLink(url);
  };

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleContainerClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  return (
    <div className={style.popupWrapper} onClick={handleBackdropClick}>
      <div className={style.popupContainer} onClick={handleContainerClick}>
        <div className={style.qrCodeContainer}>
          <Image
            className={style.closeButton}
            src={IMAGE_PATHS.ICONS.CLOSE}
            alt="close"
            width={GENERAL.IMAGE_SIZES.EXTRA_LARGE}
            height={GENERAL.IMAGE_SIZES.EXTRA_LARGE}
            onClick={onClose}
          />
          <h2 className={style.title}>{UI_TEXT.POPUP.SCAN_QR_TITLE}</h2>
          <Image
            src={IMAGE_PATHS.LOGOS.AVIATION_LOGO}
            alt="markets"
            width={GENERAL.IMAGE_SIZES.LOGO_WIDTH}
            height={GENERAL.IMAGE_SIZES.LOGO_HEIGHT}
          />
          <Image src="/qr-code.svg" alt="qr-code" width={150} height={150} />
        </div>
        <button className={style.openLinkButton} onClick={handleOpenLink}>
          {UI_TEXT.POPUP.OPEN_LINK}
        </button>
      </div>
    </div>
  );
};

export default QrPopup;
